import React from 'react';
import { Button } from 'reactstrap';
import { withRouter } from 'react-router-dom'

function NavButton(props) {

  // discards the staticContext property from withRouter wrapper
  let { staticContext, children, ...rest } = props;

  return (
    <Button
      onClick={() => props.history.push(props.to)}
      {...rest}
    >
      {children}
    </Button>
  );

}

NavButton.propTypes = {
  ...Button.propTypes,
}

export default withRouter(NavButton);
